import uly from "ulysses/core";
import $ from "jquery";
import ko from "knockout";
import HalResource from "ulysses/api";
import * as ulycomms from "ulysses/features/communications/choose_template";
import wysihtml5 from "wysihtml5";
import "ulysses/controls/model";
import "bootstrap/bootstrap3-wysihtml5";

ko.bindingHandlers.texttemplate = {
    init: function (elt, va, allbindings, model, context) {
        $(elt).parent().find(".btn[data-action=placeholder]").click(function (ev) {
            ev.stopPropagation();
            var options = ko.toJS(allbindings().modeloptions);
            var extra_roots = [{
                "name": "__login",
                "key": "__login",
                "caption": _("templating_caption_logged_in", "Logged In"),
                "relations": [],
                "favourites": [],
                "expanded": false
            }];

            ko.bindingHandlers.modelfieldpicker.select_field(options, extra_roots, model)
                .then(function ([result]) {
                    var res = ko.unwrap(result.selected);
                    if (res) {
                        var path = res;
                        var txt = "${" + path + "}";
                        $(elt).insertTextAtCursor(txt).trigger("change").focus();
                    }
                })
                .fail(function () {
                    $(elt).focus();
                });
            return false;
        });
        $(elt).parent().find(".btn[data-action=loadfromfile] input:file").change(function (ev) {
            var files = evt.target.files; // FileList object

            // files is a FileList of File objects. List some properties.
            var output = [];
            var f = files[0];
            if (f) {
                var reader = new FileReader();

                // Closure to capture the file information.
                reader.onload = (e) => {
                    var contents = e.target.result;
                    $(elt).val(contents);
                }
                // Read in the image file as a data URL.
                reader.readAsText(f);
            }
            //return false;
        });
        $(elt).parent().find(".btn[data-action=loadfromtemplate]").click(function (ev) {
            ev.stopPropagation();
            var options = ko.unwrap(allbindings().modeloptions) || {};
            var entity = ko.unwrap(options.entity);
            if (entity) {
                entity = {
                    "type_name": entity
                };
            } else {
                entity = null;
            }
            var channel = ko.unwrap(options.channel);
            /*
            HACK for getting the channel
            */
            if (!channel) {
                var chan = ko.unwrap(context.$data.channel);
                if (chan && chan.key_code) {
                    channel = ko.unwrap(chan.key_code);
                }
            }
            if (!channel) {
                channel = null;
            }

            ulycomms.choose_template(entity, channel).then((result) => {
                uly.api.start().follow("uly:data").follow("find", {
                    "rel": "documenttemplate/" + result
                }).follow("uly:markup", {
                    "channel": channel
                }).then(
                    (markup_res) => {
                        var content = markup_res.markup;
                        $(elt).val(content);
                    }
                )
            }, (failure) => {
                console.log("cancelling operation:", failure);
            });
            return false;
        });

        return ko.bindingHandlers.value.init(elt, va, allbindings, model, context);
    },
    update: function (element, valueAccessor, allBindingsAccessor, viewModel, bindingContext) {
        return ko.bindingHandlers.value.update(element, valueAccessor, allBindingsAccessor, viewModel, bindingContext);
    }
};

ko.bindingHandlers.htmltemplate = {
    init: function (elt, va, bindings, model, context) {
        $(elt).val(va()());
        $(elt).on("keypress", (ev)=> {
            if ((ev.which || ev.keyCode) == 13) {
                ev.stopPropagation();
                //return false;
            }
        });
        $(elt).wysihtml5({
            "events": {
                "change": function () {
                    va()($(elt).val());
                },
                "blur": function () {
                    va()($(elt).val());
                },
            },
            "style": true,
            "font-styles": true,
            "emphasis": true,
            "lists": true,
            "html": true,
            "link": true,
            "image": true,
            "color": true,
            "data": true,
            "loadfromfile": true,
            "loadfromtemplate": true,
            "placeholder": true,
            parser: function (html) {
                return html;
            },
            customTemplates: {
                "placeholder": function (locale, options) {
                    var size = (options && options.size) ? " btn-" + options.size : "";
                    return "<li>" +
                        "<div class='btn-group'>" +
                        "<a " +
                        "class='btn " + size + " btn-default' " +
                        "data-wysihtml5-action='insertPlaceholder' " +
                        "title='" + (locale.html.insertPlaceholder || _("templating_insert_placeholder", "Insert Placeholder")) + "' " +
                        "tabindex='-1'>" +
                        "<i class='fa fa-code'></i>" +
                        "</a>" +
                        "</div>" +
                        "</li>";
                },
                "loadfromfile": function(locale, options) {
                    var size = (options && options.size) ? " btn-" + options.size : "";
                    return `<li>
                        <div class='btn-group'>
                            <a  class='btn ${size} btn-default'
                                title='${(locale.html.loadFromFile || _("templating_load_from_file", "Load from file..."))}'
                                tabindex='-1'
                                data-uly="loadFromFile"
                                style="position:relative">
                                <i class='fa fa-folder-open'></i>
                                <input type="file" name="loadfromfile" class="timeline-upload" />
                            </a>
                        </div>
                    </li>`;
                },
                "loadfromtemplate": function(locale, options) {
                    var size = (options && options.size) ? " btn-" + options.size : "";
                    return `<li>
                        <div class='btn-group'>
                            <a  class='btn ${size} btn-default'
                                title='${(locale.html.loadFromTemplate || _("templating_load_from_template", "Load from template..."))}'
                                tabindex='-1'
                                data-uly="loadFromTemplate"
                                style="position:relative">
                                <i class='fa fa-book'></i>
                            </a>
                        </div>
                    </li>`;
                }
            }
        });
        var wysi = $(elt).data("wysihtml5");
        var $toolbar = wysi.toolbar;
        var caretBookmark = null;
        $toolbar.find("a[data-uly=loadFromFile] input:file").change(function (evt) {
            var files = evt.target.files; // FileList object

            // files is a FileList of File objects. List some properties.
            var output = [];
            var f = files[0];
            if (f) {
                var reader = new FileReader();

                // Closure to capture the file information.
                reader.onload = (e) => {
                    var contents = e.target.result;
                    wysi.editor.currentView.element.focus();
                    wysi.editor.composer.setValue(contents);
                                        
                }
                // Read in the image file as a data URL.
                reader.readAsText(f);
            }
        });

        $toolbar.find("a[data-uly=loadFromTemplate]").click(function (evt) {
            var options = ko.unwrap(bindings().modeloptions) || {};
            var entity = ko.unwrap(options.entity);
            if (entity) {
                entity = { "type_name": entity };
            } else {
                entity = null;
            }
            var channel = ko.unwrap(options.channel);
            /*
            HACK for getting the channel
            */
            if (!channel) {
                var chan = ko.unwrap(context.$data.channel);
                if (chan && chan.key_code) {
                    channel = ko.unwrap(chan.key_code);
                }
            }
            if (!channel) {
                channel = null;
            }

            ulycomms.choose_template(entity, channel).then((result)=>{
                uly.api.start().follow("uly:data").follow("find", { "rel": "documenttemplate/" + result}).follow("uly:markup", { "channel": channel }).then(
                    (markup_res) => {
                        var content = markup_res.markup;
                        wysi.editor.currentView.element.focus();
                        wysi.editor.composer.setValue(content);
                    }
                )
            }, (failure)=>{
                console.log("cancelling operation:", failure);
            });
        });

        $toolbar.find("a[data-wysihtml5-action=insertPlaceholder]").click(function () {
            var activeButton = $(this).hasClass("wysihtml5-command-active");
            if (!activeButton) {
                wysi.editor.currentView.element.focus();
                caretBookmark = wysi.editor.composer.selection.getBookmark();
                var options = ko.toJS(bindings().modeloptions);
                var extraRoots = [{
                    "name": "__login",
                    "key": "__login",
                    "caption": _("templating_caption_logged_in", "Logged In"),
                    "relations": [],
                    "attributes": [],
                    "favourites": [],
                    "expanded": false
                }];

                ko.bindingHandlers.modelfieldpicker.select_field(options, extraRoots, model)
                    .then(function ([result]) {
                        var res = ko.unwrap(result.selected);
                        if (res) {
                            var path = res;
                            var txt = "${" + path + "}";
                            wysi.editor.currentView.element.focus();
                            if (caretBookmark) {
                                wysi.editor.composer.selection.setBookmark(caretBookmark);
                                caretBookmark = null;
                            }
                            wysi.editor.composer.commands.exec("insertPlaceholder", path);
                        }
                    }, function () {
                        $(elt).focus();
                    });
                return false;
            } else {
                return true;
            }
        });

    }

};
$.fn.getCursorPosition = function () {
    var input = this.get(0);
    if (!input) return; // No (input) element found
    if (document.selection) {
        // IE
        input.focus();
    }
    return "selectionStart" in input ? input.selectionStart : "" || Math.abs(document.selection.createRange().moveStart("character", -input.value.length));
};

$.fn.insertTextAtCursor = function (newtext) {
    this.each(function () {
        var input = this;
        if (!input) return;
        var pos = $(input).getCursorPosition();
        var text = $(input).val();
        var prefix = text.substring(0, pos);
        var suffix = text.substring(pos, text.length);
        text = prefix + newtext + suffix;
        var newpos = prefix.length + newtext.length;
        $(input).val(text);

        //update The cursor position
        setCaretPosition(input, newpos);
    });
    return this;
};

var PasteTag = function (ControlOnWhichToBePasted, TextToBePasted) {
    //Get the position where to be paste

    var CaretPos = 0;
    // IE Support
    if (document.selection) {

        ControlOnWhichToBePasted.focus();
        var Sel = document.selection.createRange();

        Sel.moveStart("character", -ControlOnWhichToBePasted.value.length);

        CaretPos = Sel.text.length;
    }
    // Firefox support
    else if (ControlOnWhichToBePasted.selectionStart || ControlOnWhichToBePasted.selectionStart == "0")
        CaretPos = ControlOnWhichToBePasted.selectionStart;

    //paste the text
    var WholeString = ControlOnWhichToBePasted.val();
    var txt1 = WholeString.substring(0, CaretPos);
    var txt2 = WholeString.substring(CaretPos, WholeString.length);
    WholeString = txt1 + TextToBePasted + txt2;
    var CaretPos = txt1.length + TextToBePasted.length;
    ControlOnWhichToBePasted.val(WholeString);

    //update The cursor position
    setCaretPosition(ControlOnWhichToBePasted, CaretPos);
};

var setCaretPosition = function (ControlOnWhichToBePasted, pos) {

    if (ControlOnWhichToBePasted.setSelectionRange) {
        ControlOnWhichToBePasted.focus();
        ControlOnWhichToBePasted.setSelectionRange(pos, pos);
    } else if (ControlOnWhichToBePasted.createTextRange) {
        var range = ControlOnWhichToBePasted.createTextRange();
        range.collapse(true);
        range.moveEnd("character", pos);
        range.moveStart("character", pos);
        range.select();
    }
};

wysihtml5.commands.insertPlaceholder = {
    
    exec: function (composer, command, value) {

        var doc = composer.doc,
            phSpan = this.state(composer),
            textNode,
            i,
            parent;

        if (phSpan) {
            //we are on a placeholder span
            //set the caret before it and delete it
            composer.selection.setBefore(phSpan);
            parent = phSpan.parentNode;
            parent.removeChild(phSpan);

            // and it's parent <a> too if it hasn't got any other relevant child nodes
            wysihtml5.dom.removeEmptyTextNodes(parent);
            if (parent.nodeName === "A" && !parent.firstChild) {
                composer.selection.setAfter(parent);
                parent.parentNode.removeChild(parent);
            }

            // firefox and ie sometimes don't remove the image handles, even though the image got removed
            wysihtml5.quirks.redraw(composer.element);
            return;
        }

        phSpan = doc.createElement("SPAN");
        textNode = doc.createTextNode("${" + value + "}");
        phSpan["class"] = "uly-placeholder";

        phSpan.appendChild(textNode);
        composer.selection.insertNode(phSpan);
        composer.selection.setAfter(phSpan);

    },
    value: function (composer) {
        
        return false;
    },
    state: function (composer) {
        return false;
    }
};